import { create } from 'zustand'
import TimeRecordApi from '../apis/staff/time-record'
import { EventInput, MonthlySummary } from '../pages/staff/TimeSheet'

type TimeSheetStore = {
  timeRecords: EventInput[]
  monthlySummary: MonthlySummary[]
  setTimeRecords: (month: number, year: number, staffCode: string) => Promise<boolean>
  staffSelectedCode: string
  setStaffSelectedCode(userID: string): void
}

export const useTimeSheetStore = create<TimeSheetStore>((set, get) => ({
  monthlySummary: [],
  timeRecords: [],
  setTimeRecords: (month: number, year: number, staffCode: string): Promise<boolean> => {
    return new Promise((response, reject) => {
      TimeRecordApi.list(`${month}-${year}`, staffCode)
        .then((res) => {
          const { data } = res
          const newEvents = data.checks.reduce<EventInput[]>((result, check) => {
            const startDate = new Date(check.date)
            if (
              startDate &&
              startDate.getMonth() + 1 === month &&
              startDate.getFullYear() === year
            ) {
              result.push({
                title: check.type,
                extendedProps: check,
                start: startDate,
                allDay: true,
                staffCode: staffCode
              })
            }
            return result
          }, [])

          const newTimeRecords = get()
            .timeRecords.filter((event) => {
              const startDate = new Date(event.start)
              return startDate.getMonth() + 1 !== month || startDate.getFullYear() !== year
            })
            .concat(newEvents)

          const newMonthlySummary: MonthlySummary[] = [
            ...get().monthlySummary.filter(
              (monthlySummary) => monthlySummary.month !== month || monthlySummary.year !== year
            ),
            {
              month,
              year,
              totalWorks: data.totalWorks,
              totalLate: data.totalLate,
              totalWfhNum: data.totalWfhNum,
              totalOtTime: data.totalOtTime,
              totalRemainingDay: data.totalRemainingDay
            }
          ]

          set({
            timeRecords: [...newTimeRecords],
            monthlySummary: [...newMonthlySummary]
          })
          response(true)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  staffSelectedCode: '',
  setStaffSelectedCode(userID: string) {
    set({ staffSelectedCode: userID })
  }
}))
